import angular from 'angular';

import QuicksightEmbed from './quicksight-embed/quicksight-embed';

const Components = angular.module('control-room.dashboard.components', [QuicksightEmbed.name]);

export default Components;
